package org.multiplatform.kotfolio.pages.kids

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("indian_festival")
@Composable
fun KidsIndianFestivalPage() {
    BlogLayout(
        PageProperties(
            "Indian Festival",
            "Religious festivals are special days celebrated by people of a particular religion." ),
        BlogProperties("Kids", "Indian Festival")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "New words",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Festivals",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Religions",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Culture",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Language",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "President",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Harvest Festival",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Bonfire",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Decorate",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Traditional",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Attraction",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Gur-Rewari",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Hoist",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Parade",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Participate",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Procession",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Festival",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A festival is a special time when people come together to celebrate and have fun.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "You get to dress up in your favourite clothes.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Eat lots of yummy food.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Dance to awesome music.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Play games with your friends and family.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Types of Festival",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "National Festival: 1) Independence Day, 2) 26th January 3) Mahatma Gandhi 4) Teachers Day 5) Children's Day\n Festivals celebrated in the country by all the people. Celebrated at schools, offices, government organisation and universities.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Religious Festival: 1) Dussehra 2) Diwali 3) Eid 4) Christmas 5) Holi 6) Gurupurab\nReligious festivals are special days celebrated by people of a particular religion.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Harvest Festival: 1) Pongal 2) Makar Sankranti  3) Bihu 4) Onam\n A harvest festival is when we say thank you to farmers and nature. We celebrate after crops are ready to eat.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Independence Day",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "India became independent country on 15th August 1947. Indian Flag is hoisted by Prime Minister in Red Fort, New Delhi.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "26th January",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "India became republic country on 26th January 1950. Grandly celebrated in New Delhi with parades and processions.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Mahatma Gandhi",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Birthday of Mahatma Gandhi 2nd of October every year. People call him Bapu ji He is also called \"Father of the Nation\". ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Dr. Sarvepalli Radhakrishna (Teachers Day)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Dr. Sarvepalli Radhakrishnan's birthday celebrated as Teachers Day. Celebrated on 5th of September every year. ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Children's Day",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Jawaharlal Nehru's birthday is celebrated as Children's Day. Celebrated on 14th of November every year.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Dussehra",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Dussehra tells us how good wins over bad.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Lord Rama killed Ravana on this day.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Diwali",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Diwali is called as \"Festival of lights\"",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It comes 20 days after Dussehra.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "People decorate houses with electric bulbs, candles, flowers, rangoli and diyas.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We worship Goddess Lakshmi.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "People exchange gifts and sweets. They enjoy delicious sweets and wear new clothes. Some people burst crackers on this day.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Christmas",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Christmas is celebrated on 25th December every year.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It is the birthday of Jesus Christ.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "People go to church to offer special prayers at midnight.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Children wait for Santa Claus for gifts. People decorate the Christmas tree.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Holi",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Holi, Mahavir Jayanti, Parsi New Year and Buddha Poornima are some other festivals celebrated in India.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Holi is celebrated in the month of February/March.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "People play with colours, children use pichkaris to throw water.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Gurupurab",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Guru Nanak Jayanti is also known as Gurpurab. It is the birthday of ten Sikh gurus.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "People go to gurudwara to offer prayers.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "They eat from common kitchen called langar. Community lunch or langar is offered to everyone who visits gurudwaras.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Ganesh Chaturthi",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Hindus celebrate Ganesh Chaturthi to show their love and devotion for Lord Ganesha. A special sweet called modak is made and offered to Lord Ganesha on this day.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Pongal",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Pongal is a 4-day festival in Tamil Nadu. We cook sweet rice and decorate cows. ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We celebrate after crops are ready to eat.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Makar Sankranti",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Most popular festival in North India. On Makar Sankranti, we fly colorful kites. We eat til (sesame) sweets.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We celebrate after crops are ready to eat.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Bihu",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Bihu is a dance and food festival in Assam. People sing, dance, and wear pretty clothes. Families eat together with joy.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We celebrate after crops are ready to eat.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Onam",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Onam is a big harvest festival in Kerala. People have boat races and make flower designs. We celebrate King Mahabali's visit. Onam Sadya is a traditional vegetarian meal served on banana leaves.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We celebrate after crops are ready to eat.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Lohri",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Lohri is a happy harvest festival from Punjab. We light a big bonfire and dance around it. We eat popcorn, peanuts, and reoris (sweet treats).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We celebrate after crops are ready to eat.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Arrange the following numbers to form the year in which India celebrated its first Republic Day? India celebrated its first Republic Day on January 26, 1950",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Usually, during which of these festivals does one hang a lantern called 'aakash kandil'? Diwali",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "April - ‘Earth Day’, celebrated in support of environmental protection, is observed in which month?",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "December - In which month is the Hornbill Festival celebrated in Nagaland?",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these is a pair of two different names for the same festival? Dussehra-Vijayadashami",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these names means a 'row of lights or lamps' in Sanskrit? Deepali",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "During Diwali, goddess Laxmi is worshipped for gaining which of these? wealth, prosperity, fortune, happiness, and success.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Arrange these days as they are celebrated in India, from January to December? International Yoga Day, Teachers' Day, Gandhi Jayanti, Children's Day",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these dates, the birthday of Maulana Azad, is observed as National Education Day in India? November 11",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "People of which state traditionally celebrate Bihu by consuming jolpan? Assam",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Arrange these celebrations in the order they typically take place in a calendar year starting from January? Republic Day, Holi, Diwali, Christmas",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Govardhan Puja is normally held during which festival? Diwali",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The festival of Rakhi falls on which day of the lunar month of Shravana? Purnima",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }
        }
    }
}

//victory (Conquest) (વિજય) - opposite (defeat)
//holy - cursed

//Ghashiram Kotwal is a Marathi play written by playwright Vijay Tendulkar in 1972 as a response to the rise of a local political party, in Maharashtra.
//Which of these festivals is celebrated last in a calendar year? Deepawali
//Which of these patriots did not live to see India become independent? Lala Lajpat Rai
//'Good Governance Day' is observed on 25th December in honour of which former PM's birth anniversary? Atal Bihari Vajpayee, a day established in 2014 to promote government accountability and citizen awareness.
//Punjabi - Which language is primarily written in the Shahmukhi script?
//Chacha Chaudhary - Who among these is seen in a new comic, in partnership with the Election Commission of India, to raise awareness about voting among youngsters?
//Karna - According to the Mahabharata, who among these was not killed by Bhima?
